var _path, _rect, _text, _path2, _ellipse, _rect2, _rect3, _rect4, _text2, _path3, _ellipse2, _ellipse3, _ellipse4, _path4, _rect5, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatIs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 200 L340 200",
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 70,
    width: 130,
    height: 120,
    rx: 10,
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 98,
    fill: "#38bdf8",
    fontFamily: "system-ui,sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "FACT")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85 175 Q115 110 115 110 Q115 110 145 175 Z",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115,
    cy: 140,
    rx: 16,
    ry: 12,
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 155,
    width: 50,
    height: 5,
    rx: 2,
    stroke: "#fafcfb",
    strokeWidth: 1.2,
    strokeOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 166,
    width: 40,
    height: 4,
    rx: 1,
    stroke: "#fafcfb",
    strokeWidth: 1,
    strokeOpacity: 0.35
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 70,
    width: 130,
    height: 120,
    rx: 10,
    stroke: "#fbbf24",
    strokeWidth: 1.5
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 248,
    y: 98,
    fill: "#fbbf24",
    fontFamily: "system-ui,sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "STORY")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245 175 Q275 110 275 110 Q275 110 305 175 Z",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 275,
    cy: 140,
    rx: 16,
    ry: 12,
    stroke: "#fbbf24",
    strokeWidth: 1.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262,
    cy: 133,
    rx: 12,
    ry: 7,
    stroke: "#fafcfb",
    strokeWidth: 1,
    strokeOpacity: 0.35
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 288,
    cy: 147,
    rx: 9,
    ry: 6,
    stroke: "#fafcfb",
    strokeWidth: 1,
    strokeOpacity: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M195 140 L210 140 M205 135 L210 140 L205 145",
    stroke: "#fbbf24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 215,
    width: 170,
    height: 28,
    rx: 6,
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 128,
    y: 233,
    fill: "#fafcfb",
    fontFamily: "system-ui,sans-serif",
    fontSize: 11,
    opacity: 0.85
  }, "Separate facts from stories")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatIs);
export default __webpack_public_path__ + "static/media/what-is.38cfa7810ee53ad9856c721a8fdc8061.svg";
export { ForwardRef as ReactComponent };